<template>
  <div>
    <top-nav></top-nav>
    <div class="not-found">
      <div class="badge">ERROR 404</div>
      <h1 class="heading">That page doesn't exist</h1>
      <p class="subtext">It may have moved, or the link may be out of date. Here's where most people go next.</p>
      <div class="actions">
        <button class="btn-primary" @click="handleDemoBooking(true)">Book a free demo</button>
        <button class="btn-secondary" @click="goRouter('')">Back to home</button>
      </div>
      <div class="divider">
        <span class="line"></span>
        <span class="divider-text">Or jump to</span>
        <span class="line"></span>
      </div>
      <div class="quick-links">
        <span tabindex="0" role="link" @click="goRouter('/Features')" @keyup.enter="goRouter('/Features')">{{ $t("topNav.features") }}</span>
        <span tabindex="0" role="link" @click="goRouter('/Pricing')" @keyup.enter="goRouter('/Pricing')">{{ $t("topNav.pricing") }}</span>
        <span tabindex="0" role="link" @click="goRouter('/Blogs')" @keyup.enter="goRouter('/Blogs')">{{ $t("topNav.blogs") }}</span>
        <span tabindex="0" role="link" @click="goRouter('/AboutUs')" @keyup.enter="goRouter('/AboutUs')">About</span>
        <span tabindex="0" role="link" @click="goRouter('', '#contact')" @keyup.enter="goRouter('', '#contact')">{{ $t("topNav.contact_us") }}</span>
      </div>
      <book-demo v-if="showBookingDialog" :show="showBookingDialog" @update:show="handleDemoBooking"></book-demo>
    </div>
    <foot-nav></foot-nav>
  </div>
</template>

<script>
export default {
  metaInfo: {
    meta: [
      { vmid: 'robots', name: 'robots', content: 'noindex, follow' }
    ]
  },
  data() {
    return {
      showBookingDialog: false
    }
  },
  methods: {
    handleDemoBooking(open = false) {
      const base = '';
      if (open) {
        history.pushState({ popup: 'open' }, '', `${base}/bookdemo`);
      } else {
        history.replaceState({}, '', base || '/');
      }
      this.showBookingDialog = open;
    },
    goRouter(path, section) {
      const socialmedia = localStorage.getItem('socialmedia');
      const newPath = path + (socialmedia != '' ? `/${socialmedia}` : '/');
      this.$router.push({ path: newPath, hash: section }).catch(() => {});
    }
  },
  components: {
    "top-nav": () => localStorage.getItem('isPc') == 'true' ?
        import("@/components/PC/TopNav.vue") :
        import("@/components/APP/TopNav.vue"),
    "foot-nav": () => localStorage.getItem('isPc') == 'true' ?
        import("@/components/PC/FooterNav.vue") :
        import("@/components/APP/FooterNav.vue"),
    "book-demo": () => localStorage.getItem('isPc') == 'true' ?
        import("@/components/PC/BookDemo/Index.vue") :
        import("@/components/APP/BookDemo/Index.vue")
  }
}
</script>

<style lang="scss" scoped>
.not-found {
  min-height: calc(100vh - 90px);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 130px 20px 80px;
  background: #F5F8FC;
  .badge {
    display: inline-block;
    padding: 10px 16px;
    border-radius: 999px;
    background: #E8F3FF;
    color: #1890ff;
    font-size: 13px;
    font-weight: 700;
    letter-spacing: 0.1em;
    margin-bottom: 24px;
  }
  .heading {
    font-family: Poppins-Bold;
    font-size: 32px;
    color: #062440;
    margin: 0 0 16px;
  }
  .subtext {
    font-family: Poppins;
    font-size: 16px;
    color: #67788C;
    max-width: 480px;
    line-height: 1.5;
    margin: 0 0 32px;
  }
  .actions {
    display: flex;
    gap: 16px;
    margin-bottom: 40px;
    flex-wrap: wrap;
    justify-content: center;
  }
  .btn-primary, .btn-secondary {
    height: 46px;
    padding: 0 24px;
    border-radius: 6px;
    font-size: 15px;
    cursor: pointer;
    border: none;
  }
  .btn-primary {
    background: #1890ff;
    color: #fff;
  }
  .btn-primary:hover {
    background: #096dd9;
  }
  .btn-secondary {
    background: #fff;
    color: #062440;
    border: 1px solid #E5E6EB;
  }
  .btn-secondary:hover {
    border-color: #1890ff;
    color: #1890ff;
  }
  .btn-primary:focus-visible, .btn-secondary:focus-visible {
    outline: 2px solid #1890ff;
    outline-offset: 2px;
  }
  .divider {
    display: flex;
    align-items: center;
    width: 100%;
    max-width: 420px;
    margin-bottom: 24px;
    .line {
      flex: 1;
      height: 1px;
      background: #E5E6EB;
    }
    .divider-text {
      padding: 0 16px;
      font-family: Poppins;
      font-size: 13px;
      color: #67788C;
      white-space: nowrap;
    }
  }
  .quick-links {
    display: flex;
    gap: 28px;
    flex-wrap: wrap;
    justify-content: center;
    span {
      font-family: Poppins;
      font-size: 14px;
      color: #1890ff;
      cursor: pointer;
    }
    span:hover {
      text-decoration: underline;
    }
    span:focus-visible {
      outline: 2px solid #1890ff;
      outline-offset: 2px;
    }
  }
}
</style>
